module.exports = __webpack_public_path__ + "img/multi-office-function-2.cd306b5a.webp";